import React from "react"
import {
  Box,
  List,
  Typography,
  Button,
  Switch,
  FormControlLabel,
} from "@material-ui/core"

import TicketListItem from "./TicketListItem"
import Flex from "../../lib/components/Flex"
import { TicketAssignee } from "../../constants/enums"
import useTicketColumn from "../../hooks/useTicketColumn"

function mapAssignedGroupName (assignedGroup: string) {
  if (TicketAssignee.AWAITING_KV === assignedGroup) {
    return "AWAITING_DOCUMENTS"
  }

  return assignedGroup
}

export default function TrackingColumn (
  { assignedGroup, tagFilters = [], tagData }:
  {
    assignedGroup: string
    tagFilters: string[]
    tagData: {name: string, id: string}[]
  },
) {
  const {
    ticketDocs,
    awakeCount,
    snoozedCount,
    hasMore,
    loadingMore,
    loadMore,
    shouldLoadAll,
    setShouldLoadAll,
  } = useTicketColumn({
    assignedGroup,
    claimType: "bmw-claim",
    tagFilters,
    tagData,
    skipLeads: true,
  })

  return (
    <Box p={0.5}>
      <Typography variant='h6' color='textPrimary' gutterBottom align='center'>
        {mapAssignedGroupName(assignedGroup)}
      </Typography>
      <div
        style={{padding: 8,
          textAlign: "center",
          display: "flex",
          justifyContent: "center"}}>
        <div style={{padding: 4, background: "#8bc34a",
          borderRadius: 8, marginRight: 4, width: "50%"}}>
          Awake: {awakeCount}
        </div>
        <div style={{padding: 4, background: "#78909c",
          borderRadius: 8, width: "50%"}}>
          Snoozed: {snoozedCount}
        </div>
      </div>
      <Flex center>
        <FormControlLabel
          control={
            <Switch
              checked={shouldLoadAll}
              onChange={() => setShouldLoadAll(!shouldLoadAll)}
            />
          }
          label='Load All'
          // @ts-expect-error TODO: variant does not exist?
          variant='filled'
          labelPlacement='start'
        />
      </Flex>
      <List dense>
        {ticketDocs.map(ticketDoc => {
          const { claimId } = ticketDoc.data()
          const link = `/bmw-claims/${claimId}/show`
          return (
            <TicketListItem
              ticketDoc={ticketDoc}
              key={ticketDoc.id}
              link={link}
              claimId={claimId}
              showPhoneIcons
              colorItemsByStatus={false}
            />
          )
        })}
        {hasMore && (
          <Button
            fullWidth
            disabled={loadingMore}
            onClick={loadMore}
          >
            Show More
          </Button>
        )}
      </List>
    </Box>
  )
}
